import { FormControlController } from './formControl.controller';
import template from './formControl.html';

export function FormControlDirective() {
  'ngInject';

  return {
    restrict: 'E',
    require: 'ngModel',
    template,
    transclude: {
      topLabel: '?topLabel',
    },
    scope: {
      autocomplete: '@',
      autofocus: '=?',
      className: '@',
      devMode: '<',
      disabled: '<',
      ieDisabled: '<',
      doFocus: '=?',
      doValidate: '=?',
      form: '<',
      icon: '@',
      iconText: '@',
      id: '@',
      testId: '@',
      inline: '@',
      label: '@',
      labelValues: '=',
      messages: '<',
      model: '=',
      modelOptions: '<',
      name: '@',
      onBlur: '&',
      onChange: '&',
      onClick: '&',
      onFocus: '&',
      onKeypress: '&',
      onRemove: '&',
      onSelect: '&',
      onUpload: '&',
      onUploadFail: '&',
      onUploadFinally: '&',
      onUploadStart: '&',
      options: '<',
      placeholder: '@',
      readonly: '<',
      required: '<',
      rows: '@',
      size: '@',
      suggest: '<',
      suggestSelect: '&',
      suggestSrc: '&',
      type: '@',
      typeModifier: '@',
      typeOptions: '<',
      uncheckable: '@',
      value: '=',
    },
    bindToController: true,
    controller: FormControlController,
    controllerAs: 'vm',
  };
}
